import { ApiClient } from './base/apiClient';
import type {
  GetSystemConfigRequest,
  GetSystemConfigResponse,
} from '~/types/api/system/getSystemConfig';
import type { ApiResponse } from '~/types/api/common/apiResponse';

const BASE_PATH = '/system';

/**
 * システム設定に関するリポジトリ
 */
export class SystemRepository {
  private apiClient: ApiClient;

  constructor(displayId: string) {
    this.apiClient = new ApiClient(displayId);
  }

  /**
   * [sp-api-606] システム設定取得API
   *
   * @param request リクエスト
   * @returns レスポンス
   */
  async getSystemConfig(
    request: GetSystemConfigRequest,
  ): Promise<ApiResponse<GetSystemConfigResponse>> {
    const query = new URLSearchParams();
    if (request.itemKey !== undefined) {
      query.append('itemKey', request.itemKey);
    }
    if (request.itemCd !== undefined) {
      query.append('itemCd', request.itemCd);
    }

    return await this.apiClient.get<GetSystemConfigResponse>(BASE_PATH + '/config', query);
  }
}
